import {z}from'zod';const o=z.object({type:z.literal("server"),message:z.string().optional(),stack:z.any().optional()});export{o as RestValidationServerSchema};